const setSettingsDialogOpen = (settingsDialogOpen) => (dispatch) => {
dispatch({
    type: 'SET_SETTINGS_DIALOG_OPEN',
    settingsDialogOpen
})
}

export default setSettingsDialogOpen;